import React, { Component } from "react";
import "./App.css";
import alta_group from "./images/alta_group.png";
import Header from "./Header";
import Footer from "./Footer";
import { Container, Row, Col } from "reactstrap";
import BayBridge from "./images/Background_Bay_Bridge.jpg";
import CapeTown from "./images/Background_Cape_Town.jpg";
import GoldenGate from "./images/Background_Golden_Gate_Bridge.jpg";
import Jakarta from "./images/Background_Jakarta.jpg";
import MexicoCity from "./images/Background_Mexico_City.jpg";

class Main extends Component {
  constructor(props) {
    super(props);
    this.state = {
      intervalId: 0,
      currentCount: 0
    };
  }

  componentDidMount() {
    const intervalId = setInterval(this.timer.bind(this), 4000);
    // store intervalId in the state so it can be accessed later:
    this.setState({ intervalId: intervalId });
  }

  componentWillUnmount() {
    // use intervalId from the state to clear the interval
    clearInterval(this.state.intervalId);
  }

  timer() {
    console.log(this.state);
    this.setState({ currentCount: this.state.currentCount + 1 });
    if (this.state.currentCount >= 6) {
      this.setState({ currentCount: 0 });
    }
  }

  render() {
    const background =
      "main-container main-container-bg-" + this.state.currentCount;

    return (
      <div className="AppMain">
        <Header />
        <div className={background}>
          <div className="main-div">
            <h1>
              Helping the Americas' best entrepreneurs take their business
              global.
            </h1>
          </div>
          <div className="main-div">
            <a className="main-button" href="/companies/">
              See our Portfolio &gt;
            </a>
          </div>
        </div>
        <div className="main-page">
          <h1>Alta Offices & Global Partners</h1>
          <img src={alta_group} alt="Alta Ventures Worldwide" />
          <Container fluid>
            <Row>
              <Col xs="12" sm="3">
                <p className="red-accent">
                  "Talent is equally distributed, but opportunity is not."
                </p>
              </Col>
              <Col xs="12" sm="9">
                <p>
                  Alta Global Ventures supports passionate entrepreneurs from
                  the top ecosystems around the world. We work closely with
                  founders to expand internationally and grow their companies
                  into the global iconic companies of tomorrow.
                </p>

                <p>
                  Alta Global invests directly into venture stage and growth
                  stage companies targeting high-growth markets and connects
                  them to key resources throughout our global network. Through
                  our global partners, we also support seed stage companies on
                  five continents and more than 20 countries around the world.
                </p>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="main-contactus" id="contact">
          <h1>Contact Us</h1>
          <div>
            Alta Global Ventures <br />
            3315 Mayflower Avenue, Suite 1<br />
            Lehi, Utah 84043
            <br />
            <br />
          </div>
          <div>deals@altaglobal.com</div>
        </div>
        <Footer />
        <img src={BayBridge} style={{ display: "none" }} alt="" />
        <img src={CapeTown} style={{ display: "none" }} alt="" />
        <img src={GoldenGate} style={{ display: "none" }} alt="" />
        <img src={Jakarta} style={{ display: "none" }} alt="" />
        <img src={MexicoCity} style={{ display: "none" }} alt="" />
      </div>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/Main.js